import { TCountryCode } from 'types';

export const languages: { [key: string]: string } = {
	RU: 'Русский',
	EN: 'English',
	// DE: 'Deutsch',
	// UA: 'Українська',
};

export const LANGUAGE_TO_COUNTRY_CODE_MAP: { [key: string]: TCountryCode } = {
	RU: 'RU',
	EN: 'GB',
	// DE: 'DE',
	// UA: 'UA',
};

export const regexForStartLinks = /(http(s)?:\/\/)/g;
export const regexForWatchesCommands = /^[A-Za-z]{3}-\d{3}$/;
export const int32 = 2147483647;

export const aspectRatiosForStyleSettings: { [key: string]: { vertical: number; horizontal: number } } = {
	cards: { vertical: 593 / 246, horizontal: 310 / 498 },
	game_banner: { vertical: 569 / 99, horizontal: 800 / 99 },
	reserve_image: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	game_dialog_background: { vertical: 800 / 1280, horizontal: 480 / 371 },
	fiscal_receipt_dialog_background: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	entertainment_background: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	thanks_for_your_order: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	how_it_works: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	free_right_button: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	screen_saver_for_ordering: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	screen_saver_without_ordering: { vertical: 800 / 1280, horizontal: 1280 / 800 },
	default_no_dish_image: { vertical: 267 / 180, horizontal: 377 / 180 },
	split_payment_images: { vertical: 380 / 352, horizontal: 380 / 352 },
	call_waiter: { vertical: 760 / 1240, horizontal: 1240 / 760 },
};
